// src/pages/ComplaintConfirmation.jsx
import React from "react";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function ComplaintConfirmation() {
  const nav = useNavigate();

  return (
    <div
     style={{
       background: "dark no-repeat center/cover",
       height: "100vh",
       display: "flex",
       justifyContent: "center",
       alignItems: "center",
     }}
     className="p-4"
   >
      <Container className="text-center py-5 bg-white bg-opacity-75 rounded">
        <h1 className="display-4">Thank For Submitting!</h1>
        <p className="lead"> Your complaint has been successfully submitted. 
          Our support team will review it shortly and get back to you as soon as possible
</p>
        <Button
          variant="danger"
          size="lg"
          onClick={() => nav("/")}
        >
          Back to Complaints
        </Button>
      </Container>
    </div>
  );
}
